export const ERR_OK = 0

/**
 * 权限系统基础接口前缀
 */
export const baseUrl = '/api/iam-manage/v1.0'
export const tokenUrl = '/iam'
export const deviceUrl = '/api/device-manage/v1.0'
export const loginCodeUrl = '/iam/kaptcha/default'
export const cautionUrl = '/api/alert/v1.0'
export const metricUrl = '/api/device-metric/v1.0'
export const cockpitUrl = '/api/device-cockpit/v1.0'
export const voiceUrl = '/api/device-communication/v1.0'
export const IhLogUrl = '/api/ih-log/v1.0'
export const ihConfigUrl = '/api/ih-config/v1.0'
export const ihupgradeUrl = '/api/ih-upgrade/v1.0'
export const ihFaceDetectUrl = '/api/ih-face-detect/v1.0'
export const ihLive = '/ih-live'
export const ihMedia = '/hwmsp/media/api'
export const mediaHttp = '/api'

export const signCode = {
  accessCode: 'abcdefg123456789',
  token: 'mspuser1',
  rtmpPrefix: 'rtmp://192.168.3.121:1935',
}

export const config = {
  // 智能安全帽路径
  ihUrl: '/',
  // 智能安全帽路径
  ihUrlApache: '/',
}
// 系统权限列表
export const btnList = ['Monitor', 'cockpit', 'Caution', 'HelmetManage', 'userList', 'rolesManage']
